import { render, staticRenderFns } from "./SearchPageManagementResult.vue?vue&type=template&id=6963ebf1&scoped=true"
import script from "./SearchPageManagementResult.vue?vue&type=script&lang=js"
export * from "./SearchPageManagementResult.vue?vue&type=script&lang=js"
import style0 from "./SearchPageManagementResult.vue?vue&type=style&index=0&id=6963ebf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963ebf1",
  null
  
)

export default component.exports